<template>
  <div>
    <div class="bg"></div>
    <div class="i-pop-box">
      <Spinner :size="48" :message="'Loading...'" :font-size="14" :line-size="7" :text-fg-color="'#fff'"></Spinner>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
export default {
  name: 'i-loading',
  components: {
    Spinner
  },
  data() {
    return {

    }
  },
  methods: {

  },

}
</script>

<style scoped="scoped" lang="less">
.bg {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .25);
}

.i-pop-box {
  position: fixed;
  z-index: 1001;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>